export type UploadItem = {
  docId: string | null;
  originalFileName: string;
  pdfUrl: string | null;
  emetteur: string;
  invoiceType: "normal" | "resto" | null;
  modeRef: string;
  montantCent: number | null;
  dateFacture: Date | null;
  paymentDueDate: Date | null;
  montantTitresCent: number | null;
  montantFraisCent: number | null;
  error: string | null;
};

export type UploadState = {
  items: UploadItem[];
  selectedItemIndex: number;
};

export type UploadAction =
  | { type: "replace"; items: UploadItem[] }
  | { type: "update"; index: number; item: UploadItem }
  | { type: "select"; index: number }
  | { type: "remove"; index: number }
  | { type: "removeCreated"; docIds: Set<string> };

const clampSelectedIndex = (itemsLength: number, selectedItemIndex: number) =>
  Math.max(0, Math.min(selectedItemIndex, Math.max(0, itemsLength - 1)));

export const uploadReducer = (
  state: UploadState,
  action: UploadAction,
): UploadState => {
  if (action.type === "replace") {
    return { items: action.items, selectedItemIndex: 0 };
  }
  if (action.type === "select") {
    return { ...state, selectedItemIndex: action.index };
  }
  if (action.type === "update") {
    return {
      ...state,
      items: state.items.map((item, index) =>
        index === action.index ? action.item : item,
      ),
    };
  }
  if (action.type === "remove") {
    const items = state.items.filter((_, index) => index !== action.index);
    const removedBeforeSelection = action.index < state.selectedItemIndex;
    const selectedItemIndex = clampSelectedIndex(
      items.length,
      state.selectedItemIndex - (removedBeforeSelection ? 1 : 0),
    );
    return { items, selectedItemIndex };
  }

  const items = state.items.filter(
    (item) => !item.docId || !action.docIds.has(item.docId),
  );
  return {
    items,
    selectedItemIndex: clampSelectedIndex(items.length, state.selectedItemIndex),
  };
};
